// web-dialog.service.ts
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from './dialog.service';
import { IGroupedCard } from 'src/app/models/groupedCard';
import { WebpopupdialogComponent } from 'src/app/web/webpopupdialog/webpopupdialog.component';
import { MissingTexturesSyncComponent } from '../components/upload-missing-textures/missing-textures-sync.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebDialogService extends DialogService {
  constructor(private dialog: MatDialog) {
    super();
  }

  openUploadErrorDialog(card: IGroupedCard): Observable<boolean> {
    const dialogConfig = {
      data: {
        heading: `Model "${card.title}".\n ${card.details} please contact support`, // added newline symbol at the end
        mainBtnTitle: 'Mark as Read',
        inputValue: '',
        isInputHidden: true
      },
      restoreFocus: false,
      panelClass: 'webpopup-overlay'
    };

    const dialogRef = this.dialog.open(WebpopupdialogComponent, dialogConfig);

    return dialogRef.afterClosed();
  }

  openMissingTextureMappingDialog(card: IGroupedCard): Observable<boolean> {
    const dialogConfig = {
      data: {
        modelData: card,
      },
      restoreFocus: false,
      panelClass: 'webpopup-overlay',
      width: '450px',
      maxHeight: '80vh'
    };

    const dialogRef = this.dialog.open(MissingTexturesSyncComponent, dialogConfig);

    return dialogRef.afterClosed();
  }
}
